var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pa-2"},[_c('span',{staticStyle:{"white-space":"pre"},domProps:{"textContent":_vm._s(_vm.computedTitle)}})])}
var staticRenderFns = []

export { render, staticRenderFns }